import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import { apiSlice } from './api'

const env = document.querySelector('meta[name="environment"]')?.content ?? 'unknown'

export const setupStore = preloadedState => {
  return configureStore({
    preloadedState: preloadedState,
    reducer: {
      [apiSlice.reducerPath]: apiSlice.reducer
    },
    middleware: getDefaultMiddleware => filteredWithLogger(getDefaultMiddleware)
      .concat(apiSlice.middleware),
    enhancers: (getDefaultEnhancers) =>
      getDefaultEnhancers({
        autoBatch: { type: 'timer', timeout: 10 }
      })
  })
}

const filteredWithLogger = getMiddleware => (env === 'develop') ? getMiddleware().concat(logger) : getMiddleware()
